export enum CampaignAgentAccess {
  EVERYONE = "EVERYONE",
  SELECTED = "SELECTED",
}
